import { useEffect, useRef, useSyncExternalStore } from 'react'
import { useLocation } from 'react-router-dom'

import { AppToast } from '../../shared/ui/AppToast'
import {
  dismissAppToast,
  getAppToastSnapshot,
  showAppToast,
  subscribeToAppToast,
} from '../../shared/ui/app-toast-controller'

type ToastLocationState = {
  notice?: unknown
  severity?: unknown
}

export function RouteToast() {
  const location = useLocation()
  const shownLocationKeys = useRef(new Set<string>())
  const notification = useSyncExternalStore(
    subscribeToAppToast,
    getAppToastSnapshot,
    getAppToastSnapshot,
  )
  const state = location.state as ToastLocationState | null
  const message = typeof state?.notice === 'string' ? state.notice : ''
  const severity =
    state?.severity === 'error' ||
    state?.severity === 'info' ||
    state?.severity === 'warning'
      ? state.severity
      : 'success'

  useEffect(() => {
    if (!message || shownLocationKeys.current.has(location.key)) return
    shownLocationKeys.current.add(location.key)
    showAppToast(message, severity)
  }, [location.key, message, severity])

  return (
    <AppToast
      message={notification?.message ?? ''}
      onClose={() => dismissAppToast(notification?.id)}
      open={notification !== null}
      severity={notification?.severity ?? 'info'}
    />
  )
}
